import { Label } from '@gripp/shared-logic';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes';
import { MultiItemSelector } from '../forms/multiItemSelector';

type LabelSelectorProps = {
  selectedLabels: Label[];
  availableLabels: Label[];
  onLabelsChange: (labels: Label[]) => void;
  onCreateLabel?: (name: string) => Promise<Label>;
  disabled?: boolean;
  title?: string;
  containerBackgroundColor?: string;
};

export const LabelSelector: React.FC<LabelSelectorProps> = ({
  selectedLabels,
  availableLabels,
  onLabelsChange,
  onCreateLabel,
  disabled = false,
  title,
  containerBackgroundColor = Colors.white,
}) => {
  const { t } = useTranslation();

  return (
    <MultiItemSelector
      selectedItems={selectedLabels}
      availableItems={availableLabels}
      onItemsChange={onLabelsChange}
      onCreateItem={onCreateLabel}
      disabled={disabled}
      placeholder={t('issue.common.selectLabel')}
      searchPlaceholder={t('issue.common.searchLabel')}
      createButtonText={t('issue.common.createLabel')}
      containerBackgroundColor={containerBackgroundColor}
      itemType="label"
      emptyText={t('issue.common.emptyStateMessage')}
      useCropCircle={true}
    />
  );
};
